{
  "optimizationInputsForm": {
    "sections": {
      "initialDimensions": "Dimensiones iniciales",
      "variations": "Variaciones",
      "sizesToTest": "Tamaños a probar",
      "aircraftMix": "Mix de aeronaves"
    },
    "labels": {
      "width": "Ancho ({{unit}})",
      "depth": "Profundidad ({{unit}})",
      "widthVariation": "+/- ancho ({{unit}})",
      "depthVariation": "+/- profundidad ({{unit}})",
      "searchAircraft": "Buscar por marca y modelo",
      "numberAircraft": "# Aeronaves",
      "configurations": "configuraciones"
    },
    "tableHeaders": {
      "make": "Crear",
      "model": "Modelo",
      "wingspan": "Envergadura ({{unit}})",
      "length": "Longitud ({{unit}})",
      "tailHeight": "Altura de cola ({{unit}})"
    }
  },
  "optimizationHangarResults": {
    "buttons": {
      "stop": "Parar",
      "run": "Ir"
    },
    "tableHeaders": {
      "hangar": "Hangar",
      "doors": "Puertas",
      "progress": "Progreso",
      "numberInHangar": "N.º en hangar",
      "utilization": "Utilización",
      "worst": "Peor",
      "best": "Mejor",
      "average": "Promedio"
    }
  }
}
